<template>
    <div class="quote-message" @click="gotoReply">
        <div class="author">
            {{ getAuthor() }}
        </div>
        <div class="text" v-html="getText()" />
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import { htmlUnescape } from "escape-goat";
import Autolinker from "autolinker";

export default Vue.extend({
    name: "QuoteMessage",
    props: ["message"],
    computed: {},
    methods: {
        isAudioMessage() {
            const model = this.message;
            const isAudioType = model.type === "audio";
            const isAudioMime = _.get(model, "raw.asset.mime", "").includes("audio");
            return isAudioType || isAudioMime;
        },
        isVideoMessage() {
            const model = this.message;
            const isVideoType = model.type === "video";
            const isVideoMime = _.get(model, "raw.asset.mime", "").includes("video");
            return isVideoType || isVideoMime;
        },
        isImageMessage() {
            const model = this.message;
            const isImageType = model.type === "image";
            const isImageMime = _.get(model, "raw.asset.mime", "").includes("image");
            return isImageType || isImageMime;
        },
        gotoReply() {
            let messageElement = document.getElementById(`sc-message_${this.message._id}`);
            if (!messageElement) messageElement = document.getElementById(`sc-message_${this.message.uniqMessageId}`);
            if (messageElement)
                messageElement.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest",
                });
        },
        getText() {
            if (this.isAudioMessage()) {
                return "Ses kaydı";
            } else if (this.isVideoMessage()) {
                return "Video";
            } else if (this.isImageMessage()) {
                return "Görüntü";
            } else {
                let message = this.message?.message || this.message?.description || "";
                // log.debug("message", message, message.trim, this.message);
                message = message.trim();
                let escaped = htmlUnescape(message);

                let res = Autolinker.link(escaped, {
                    className: "chatLink",
                    truncate: { length: 50, location: "smart" },
                });
                res = this.fillLinkTargetBlank(res);
                res = res.replace(/<p>&nbsp;<\/p>$/gi, "");
                return res;
            }
        },
        fillLinkTargetBlank(str) {
            let parser = new DOMParser();
            let virtualDom = parser.parseFromString(str, "text/html");
            virtualDom.querySelectorAll("a").forEach((a) => {
                a.setAttribute("target", "_blank");
            });
            return virtualDom.body.innerHTML;
        },
        getAuthor() {
            const model = this.message;
            if ((model.messageType || "").includes("visitor")) {
                return "You";
            }
            return model.username;
        },
    },
});
</script>

<style scoped lang="scss">
.quote-message {
    background: #f1f4f7;
    padding: 5px;
    margin: 3px;
    border-radius: var(--sps-radius-sm);
    border-left: 4px solid #ffa800;
    min-width: 100px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    user-select: none;

    .author {
        color: #ffa800;
        font-size: 13px;
        font-weight: 600;
    }

    .text {
        color: #1e1e2da6;
        font-size: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/QuoteMessage.vue